export const CouponCodeActionType = {
  GET_COUPON_CODE: 'GET_COUPON_CODE',
  ADD_COUPON_CODE: 'ADD_COUPON_CODE',
};
